import React from 'react'

import ErrorToast from '../../components/molecules/ErrorToast'

import { getInvoices } from '../../lib/api'

type APIInvoice = {
  number: string
  total: number
  currency: string
  link: string
  created: string
}

type InvoiceContextType = {
  invoices: APIInvoice[]
  loaded: boolean
  error: any
}

const InvoiceContext = React.createContext<InvoiceContextType>(null)

const InvoiceProvider = ({ children }) => {
  const [invoices, setInvoices] = React.useState([])
  const [loaded, setLoaded] = React.useState(false)
  const [error, setError] = React.useState(null)

  // Load invoices
  React.useEffect(() => {
    if (loaded) {
      return
    }

    getInvoices()
      .then(invoices => {
        setInvoices(invoices ?? [])
        setLoaded(true)
      })
      .catch(err => setError({ err, auto: true }))
  }, [loaded])

  return (
    <InvoiceContext.Provider value={{ invoices, loaded, error }}>
      {children}

      <ErrorToast error={error} />
    </InvoiceContext.Provider>
  )
}

export default InvoiceProvider

export const useInvoice = () => React.useContext(InvoiceContext)
